import { Link } from 'react-router-dom'
import { Breadcrumb  } from 'antd';
import './RefundPolicy.less'
import { useIntl } from 'react-intl';


export default () => {
	const intl = useIntl();
	return <div className="RefundPolicy">
		<div className="page-routers-header">
			<Breadcrumb className="page-header-content">
				<Breadcrumb.Item>
				  <a href="/">{intl.formatMessage({id: 'header.menus.home'})}</a>
				</Breadcrumb.Item>
				<Breadcrumb.Item>{intl.formatMessage({id: 'footer.menus.support.Shipping'})}</Breadcrumb.Item>
			</Breadcrumb>
		</div>
		<div className="page-footer-container">
			<div className="page-footer-content">
				<div className="page-title">{intl.formatMessage({id: 'shippingPolicy.title'})}</div>
				<div>
					<div className="content-block">
						<p>{intl.formatMessage({id: 'shippingPolicy.con1'})}</p>
						<p>{intl.formatMessage({id: 'shippingPolicy.con2'})}</p>
					</div>
					<div className="content-block">
						<p className="title" style={{fontWeight: 400}}>{intl.formatMessage({id: 'shippingPolicy.con3'})}</p>
						<div  className="content-block-left">
							<p>{intl.formatMessage({id: 'shippingPolicy.time'})}</p>
							<p>{intl.formatMessage({id: 'shippingPolicy.time.con'})}</p>
						</div>
						<div  className="content-block-right">
							<div>
								<p>{intl.formatMessage({id: 'shippingPolicy.method'})}</p>
								<p>{intl.formatMessage({id: 'shippingPolicy.method.con'})}</p>
							</div>
							<div>
								<p>{intl.formatMessage({id: 'shippingPolicy.ShippingTime'})}</p>
								<p>{intl.formatMessage({id: 'shippingPolicy.ShippingTime.con'})}</p>
							</div>
							<div>
								<p>{intl.formatMessage({id: 'shippingPolicy.ShippingFee'})}</p>
								<p>{intl.formatMessage({id: 'shippingPolicy.ShippingFee.con'})}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
}